import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { BaseRoute } from '@core/routing/helper-components/Routes';

interface NavItemProps {
  route: BaseRoute;
  isOpen: boolean;
  isActive: boolean;
  onClick: () => void;
}

export const NavItem = ({ route, isOpen, isActive, onClick }: NavItemProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(route.path);
    onClick();
  };

  return (
    <ListItem disablePadding>
      <ListItemButton
        onClick={handleClick}
        sx={{
          minHeight: 48,
          justifyContent: isOpen ? 'initial' : 'center',
          px: 2.5,
          '& .MuiListItemIcon-root': {
            color: isActive ? 'primary.main' : 'inherit',
          },
          '& .MuiListItemText-primary': {
            color: isActive ? 'primary.main' : 'inherit',
            fontWeight: 600,
          },
          '&:hover': {
            backgroundColor: 'rgba(25, 118, 210, 0.12)',
            '& .MuiListItemIcon-root': {
              color: 'primary.main',
            },
            '& .MuiListItemText-primary': {
              color: 'primary.main',
            },
          },
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: isOpen ? 2 : 'auto',
            justifyContent: 'center',
          }}
        >
          {route.icon}
        </ListItemIcon>
        <ListItemText
          primary={route.sidebarText || route.title}
          sx={{
            opacity: isOpen ? 1 : 0,
            '& .MuiListItemText-primary': {
              fontSize: 15,
              letterSpacing: '0.5px',
            },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};
